import {
  CHECK_CONTROL_PIN_INIT,
  CHECK_CONTROL_PIN_SUCCESS,
  CHECK_CONTROL_PIN_ERROR,
  CLEAR_CHECK_CONTROL_PIN,
} from '../../actions/channelBlocker/constants';

const initialState = {
  inProgress: false,
  success: false,
  error: null,
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECK_CONTROL_PIN_INIT: {
      return {
        ...initialState,
        inProgress: true,
      };
    }
    case CHECK_CONTROL_PIN_SUCCESS: {
      return {
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case CHECK_CONTROL_PIN_ERROR: {
      return {
        inProgress: false,
        success: false,
        error: action.error,
        data: null,
      };
    }
    case CLEAR_CHECK_CONTROL_PIN: {
      return initialState;
    }
    default:
      return state;
  }
};
